<header class="header__container">
  <div class="header__container__col back">
    <a (click)="backTo()">
      <span class="material-icons">keyboard_backspace</span>
    </a>
    <section class="header__container__col text">
      <a (click)="backTo()" class="label">Voltar ao</a>
      <a (click)="backTo()" class="label">Menu de Produtos</a>
    </section>
  </div>
  <seds-header
    class="header__seds"
    [userData]="userData"
    [showUser]="true"
    [logoImage]="'assets/images/logo-serasa-experian-white.svg'"
    [applicationName]="'Portal de Logons'"
    [showBadge]="false"
    [showTimer]="false"
    [showMenu]="false"
    (actionButtonMenuClick)="buttonItemClick($event)">
  </seds-header>
</header>

<pl-sub-menu></pl-sub-menu>
